const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CircleCta extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'auto',
          perView: 'auto',
          spacing: 32,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 'auto',
              spacing: 70,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  get cadence () {
    return this.dataset.cadence || 4
  }
}

if (!customElements.get('circle-cta')) {
  customElements.define('circle-cta', CircleCta)
}
